import React, { useRef, useState } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { InboundDetailHeaderMetadataPopoverContent } from './inbound-detail-header-metadata-popover-content';
import {
  InboundMetadataContactRow,
  InboundMetadataDateRow,
  InboundMetadataRows,
} from '@/screens/order-inbounds/inbound-metadata-rows/inbound-metadata-rows';
import { OrderMetadata } from '@/screens/order-inbounds/types';
import { SCREEN_PADDING, SCREEN_PADDING_SMALL } from '@/styles';
import { TouchableOpacity } from 'react-native';

interface Props {
  isUnknownContact: boolean;
  orders: OrderMetadata[];
}

export const InboundDetailHeaderMetadata: React.FC<Props> = ({
  orders,
  isUnknownContact,
}) => {
  const [styles] = useStyles();
  const wrapperRef = useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  return (
    <TouchableOpacity
      onPress={() => setIsPopoverVisible(true)}
      ref={wrapperRef}
      style={[styles.wrapper, isUnknownContact ? styles.wrapperWide : null]}
      testID="original-inbound-metadata-wrapper"
    >
      <InboundMetadataRows orders={orders}>
        <InboundMetadataContactRow />
        <InboundMetadataDateRow />
      </InboundMetadataRows>
      <BaseActionSheet
        isVisible={isPopoverVisible}
        onClose={() => setIsPopoverVisible(false)}
        popoverStyle={(_, targetPosition) => [
          styles.popover,
          {
            left: targetPosition.x + POPOVER_OFFSET.x,
            paddingHorizontal: SCREEN_PADDING_SMALL,
            paddingVertical: SCREEN_PADDING_SMALL,
            top: targetPosition.y + targetPosition.height + POPOVER_OFFSET.y,
          },
        ]}
        popoverTarget={wrapperRef?.current}
        style={styles.popoverWrapper}
      >
        <InboundDetailHeaderMetadataPopoverContent orders={orders} />
      </BaseActionSheet>
    </TouchableOpacity>
  );
};

const POPOVER_OFFSET = {
  x: 8,
  y: 4,
};
const MAX_WIDTH = 350;

const useStyles = createStyles((theme) => ({
  popover: {
    width: MAX_WIDTH - POPOVER_OFFSET.x,
  },
  popoverWrapper: {
    margin: 0,
  },
  wrapper: {
    borderRightColor: theme.sk.color.border.primary,
    borderRightStyle: 'solid',
    borderRightWidth: 1,
    justifyContent: 'center',
    maxWidth: MAX_WIDTH,
    paddingHorizontal: SCREEN_PADDING,
    paddingVertical: 12,
  },
  wrapperWide: {
    maxWidth: '100%',
  },
}));
